export const getAuthToken = () => {
    if (localStorage.getItem('user_token')) {
        return localStorage.getItem('user_token')
    }
    return '';
}

export const removeAuthToken = () => {
    localStorage.removeItem('user_token');
}

export const setAuthToken = (token) => {
    localStorage.setItem('user_token', token);
    return true
}


